import { useRef, useEffect, useState } from 'react';
import quizGame from '../assets/New folder/quiz-game.png';
import referEarn from '../assets/Images/refer-earn.jpg';

export default function Earning() {
  const sectionRef = useRef();
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full px-4 md:px-28 py-20 bg-black">
      <div className="text-center mb-12">
        <div className="inline-block bg-purple-800 text-white px-4 py-1 mb-4 rounded">How to Earn Points</div>
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">Earn Points & Unlock Rewards</h2>
        <p className="text-lg text-gray-300 mb-6 max-w-2xl mx-auto">
          Discover the ways you can earn points in our app and use them to pay bills, recharge mobiles, and more!
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-10 items-center justify-center">
        {/* Card 1: Play Quiz & Earn Points */}
        <div className={`bg-gray-900 rounded-2xl shadow-lg p-8 flex-1 max-w-md transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '0ms' }}>
          <div className="flex flex-col items-center">
            <img src={quizGame} alt="Play Quiz" className="w-40 h-40 object-contain rounded-xl mb-6 transform transition-transform duration-500 hover:scale-105" />
            <h3 className="text-2xl font-bold text-white mb-2">Play Quiz & Earn Points</h3>
            <p className="text-gray-300 text-center mb-2">Participate in fun and challenging quizzes. The more you play, the more points you earn!</p>
          </div>
        </div>
        {/* Card 2: Refer & Earn Points */}
        <div className={`bg-gray-900 rounded-2xl shadow-lg p-8 flex-1 max-w-md transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '200ms' }}>
          <div className="flex flex-col items-center">
            <img src={referEarn} alt="Refer & Earn" className="w-40 h-40 object-cover rounded-xl mb-6 transform transition-transform duration-500 hover:scale-105" />
            <h3 className="text-2xl font-bold text-white mb-2">Refer & Earn Points</h3>
            <p className="text-gray-300 text-center mb-2">Invite your friends to join the app. For every successful referral, you earn bonus points!</p>
          </div>
        </div>
      </div>
    </section>
  );
}